import MiiaFwConfig from '@/configs/config'
import {
  type ArgQueryGovernmentSettings,
  isArgQueryGovernmentSettings,
  type ResQueryGovernmentSettings,
  type resQueryGovernment
} from '@/types/accessor/api/governmentSetting/governmentSetting'
import { useApiGw } from '@/modules/miiaFw/composables/useApiGw'

export const queryGovernmentSetting = async (
  arg: ArgQueryGovernmentSettings
): Promise<ResQueryGovernmentSettings> => {
  return await new Promise((resolve, reject) => {
    const { invokeApiGwFunc } = useApiGw()
    if (isArgQueryGovernmentSettings(arg)) {
      invokeApiGwFunc(
        // API Gatewayのエンドポイント
        MiiaFwConfig.config.apiGwEndpointCommon,
        // Lambda関数をコールするためのWebAPIのサブディレクトリ
        '/governmentSettings',
        // Lambda関数に渡す引数
        {
          function: 'query',
          params: arg
        },
        // Lambda関数実行前の前処理のコールバック
        () => {},
        // 成功時のコールバック
        (data: resQueryGovernment) => {
          resolve(data.result)
        },
        // 例外受信時のコールバック(引数: エラーメッセージ)
        (message: resQueryGovernment) => {
          reject({ message })
        },
        // 予期せぬエラー(アクセス回線障害など)発生時のコールバック
        () => {
          reject({ message: 'API実行に失敗しました。(原因: アクセス回線障害など)' })
        },
        // 処理完了後に実行するコールバック
        () => {},
        false,
        true
      )
    } else {
      reject({
        message: {
          code: '210030',
          message: 'リクエスト引数の型が不正です。'
        }
      })
    }
  })
}
